module.exports = __webpack_public_path__ + "static/media/documents icon (active).2d168c38.svg";